import MediaImage from "@/components/ui/MediaImage";
/* eslint-disable @next/next/no-img-element */
import React from "react";

interface EnergyLabelProps {
  energyLabel: string;
}

const EnergyLabel: React.FC<EnergyLabelProps> = ({ energyLabel }) => {
  const labelToFileMap: { [key: string]: string } = {
    A: "A.gif",
    A1: "A1.gif",
    A2: "A2.gif",
    A2010: "A2010.gif",
    A2015: "A2015.gif",
    A2020: "A2020.gif",
    B: "B.png",
    C: "C.png",
    D: "D.png",
    E: "E.png",
    F: "F.png",
    G: "G.png",
  };

  const fileName = labelToFileMap[energyLabel];
  if (!fileName) {
    return null;
  }

  const imagePath = `/energylabels/${fileName}`;
  return <MediaImage src={imagePath} alt={`Energy Label ${energyLabel}`} />;
};

interface EnergyLabelRangeProps {
  energyLabel: string;
  energyLabelBest?: string;
  energyLabelWorst?: string;
}

export const EnergyLabelRange: React.FC<EnergyLabelRangeProps> = ({
  energyLabel,
  energyLabelBest,
  energyLabelWorst,
}) => {
  const best = energyLabelBest || energyLabel;
  const worst = energyLabelWorst || energyLabel;

  if (!best) {
    return null;
  }

  return (
    <div className="flex items-center gap-1">
      <EnergyLabel energyLabel={best} />
      {worst && worst !== best && (
        <>
          <span>-</span>
          <EnergyLabel energyLabel={worst} />
        </>
      )}
    </div>
  );
};

export const formatEnergyLabelRange = (
  energyLabel: string,
  energyLabelBest?: string,
  energyLabelWorst?: string,
): string => {
  const best = energyLabelBest || energyLabel;
  const worst = energyLabelWorst || energyLabel;

  if (!best) {
    return "";
  }

  return worst && worst !== best ? `${best} - ${worst}` : best;
};

export default EnergyLabel;
